import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loadingService: LoadingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Verifica se a requisição deve mostrar loading
    const skipLoading = req.headers.get('X-Skip-Loading') === 'true';

    // Remove o header interno antes de enviar ao servidor
    const cleanedReq = req.clone({
      headers: req.headers.delete('X-Skip-Loading'),
    });

    if (!skipLoading) {
      this.loadingService.show();
    }

    return next.handle(cleanedReq).pipe(
      finalize(() => {
        if (!skipLoading) {
          this.loadingService.hide();
        }
      }),
    );
  }
}
